export function simulateResponseDelay<T>(response: T, delay: number): Promise<T> {
	return new Promise<T>((resolve) => {
		setTimeout(() => {
			resolve(response);
		}, delay);
	});
}

export function rejectAfterDelay<T extends Error>(error: T, delay: number): Promise<never> {
	return new Promise((_, reject) => {
		setTimeout(() => {
			reject(error);
		}, delay);
	});
}

export const DEFAULT_RESPONSE_DELAY = 0;
